import {usageSvg as Icon__small__usageSvg} from '../Icon__small/Icon__small--usage.js';

export var usage = {
  name: 'usage',
  category: 'icon',
  colorable: true,
  svg: Icon__small__usageSvg,
};
